<div id="content">
  <div class="panel">
    <h2>Hersteller Report</h2>
    <mat-form-field appearance="outline" class="col-md-6">
      <mat-label>Hersteller</mat-label>
      <input type="text"
        placeholder="Hersteller"
        aria-label="Hersteller"
        matInput
        [formControl]="vendorFilter"
        [matAutocomplete]="auto"
        (change)="selectingVendor($event)">
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
          (optionSelected)="selectVendor($event.option.value.id)">
          @for (option of filteredOptions | async; track option) {
            <mat-option [value]="option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>
    @if (!loadingAds) {
      <div>
        <form [formGroup]="dataForm">
          <div class="panel row">
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="col-md-6">
                <mat-label>Ads</mat-label>
                <mat-select placeholder="Select Ad" formControlName="selectedAds">
                  @for (target of adsForDate; track target) {
                    <mat-option
                      [value]="target.id">
                      {{ target.title }} - {{ getLocation(target.location) }},
                      ({{ target.start | date:"shortDate" }} - {{ target.end | date:"shortDate" }})
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <button class="btn-primary btn" (click)="selectAd()" [disabled]="!canSelect">Select Ad</button>
              <button class="btn-secondary btn" (click)="selectCompare(currentAd)">Add Compare Ad</button>
            </div>
            <div class="col-md-12">
              <h4>Selected Ads</h4>
              @for (target of selectedAds; track target; let i = $index) {
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-6">Selected: {{ target.ad.title }}
                      - {{ getLocation(target.ad.location) }}, ({{ target.ad.start | date:"shortDate" }}
                      - {{ target.ad.end | date:"shortDate" }})
                    </div>
                    <div class="col-md-6">
                      @for (compare of target.compares; track compare; let j = $index) {
                        <p class="mt-0"
                          >{{ compare.title }}
                          - {{ getLocation(compare.location) }}, ({{ compare.start | date:"shortDate" }}
                          - {{ compare.end | date:"shortDate" }})
                          <button class="btn-round" (click)="deleteCompare(i, j)">x</button>
                        </p>
                      }
                    </div>
                  </div>
                  <hr>
                  </div>
                }
              </div>
              <div class="col-md-12">
                <button class="btn-primary btn" (click)="addNewAd()">Add new Add</button>
              </div>
              <div class="col-md-12">
                <button class="btn-primary btn" (click)="adCalculate = true">Calculate</button>
              </div>
              @if (adCalculate) {
                <div class="mt-xl col-md-12">
                  <h3>Ad Report</h3>
                  <button class="btn btn-primary" (click)="addToFile('ads')">Add To File</button>
                  @for (selectedAd of selectedAds; track selectedAd) {
                    <div class="mt-l">
                      @if (selectedAd.compares.length > 0) {
                        <phx-ad-report [selected]="selectedAd" class="ads" [idfCount]="idfs"
                        ></phx-ad-report>
                      }
                    </div>
                  }
                </div>
              }
            </div>
            <div class="row panel">
              <div class="col-md-6">
                <mat-form-field appearance="outline" class="col-md-6">
                  <mat-label>Slider</mat-label>
                  <mat-select placeholder="Select Slide" formControlName="selectedSlide">
                    @for (target of sliders; track target) {
                      <mat-option
                        [value]="target.title+'-'+ target.start + '-' + target.end">
                        {{ target.title }} ({{ target.start | date:"shortDate" }}
                        - {{ target.end | date:"shortDate" }})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <button class="btn-primary btn" (click)="selectSlide()">Select Slide</button>
                <button class="btn-secondary btn" (click)="selectCompareSlide(currentSlide)">Add Compare Slide</button>
              </div>
              <div class="col-md-12">
                <h4>Selected Slides</h4>
                @for (target of selectedSlides; track target; let i = $index) {
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-6">Selected: {{ target.slide.title }}
                        ({{ target.slide.start | date:"shortDate" }}
                        - {{ target.slide.end | date:"shortDate" }})
                      </div>
                      <div class="col-md-6">
                        @for (compare of target.compares; track compare; let j = $index) {
                          <p class="mt-0"
                            >{{ compare.title }}
                            ({{ compare.start | date:"shortDate" }}
                            - {{ compare.end | date:"shortDate" }})
                            <button class="btn-round" (click)="deleteCompare(i, j)">x</button>
                          </p>
                        }
                      </div>
                    </div>
                    <hr>
                    </div>
                  }
                </div>
                <div class="col-md-12">
                  <button class="btn-primary btn" (click)="addNewSlide()">Add new Add</button>
                </div>
                <div class="col-md-12">
                  <button class="btn-primary btn" (click)="slideCalculate = true">Calculate</button>
                </div>
                @if (slideCalculate) {
                  <div class="col-md-12 mt-xl">
                    <h3>Ad Report</h3>
                    <button class="btn btn-primary" (click)="addToFile('slides')">Add To File</button>
                    @for (selectedSlide of selectedSlides; track selectedSlide) {
                      <div class="mt-l">
                        @if (selectedSlide.compares.length > 0) {
                          <phx-slider-report [slide]="selectedSlide" class="slides"
                          ></phx-slider-report>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="row panel">
                <div class="col-md-6">
                  <mat-form-field appearance="outline" class="col-md-6">
                    <mat-label>Advertorial</mat-label>
                    <mat-select placeholder="Select Advertorial" formControlName="selectedAdvertorial">
                      @for (target of adverts; track target) {
                        <mat-option
                          [value]="target.id">
                          {{ target.title }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-6">
                  <button class="btn-primary btn">Select Advertorial</button>
                  <button class="btn-secondary btn">Add Compare Advertorial</button>
                </div>
              </div>
            </form>
          </div>
        }

        <div class="row">
          <div class="col-md-6 text-right">
            <button class="btn btn-secondary" (click)="exportPdf()" [disabled]="!added">Export Report</button>
          </div>
        </div>
      </div>
